import React from 'react';
import { Link } from 'react-router-dom';

const ContributeBanner = () => {
  return (
    <div className="grid grid-cols-1 bg-blue-600 text-white text-center sm:text-left py-2 px-4 rounded-lg shadow-md">
      <div className="">
        <h2 className="text-center text-base sm:text-lg font-bold mb-1">
          Know something we don't?
        </h2>
        <p className="text-center hidden sm:block text-sm mb-2">
          Golf Lists is where UKI golf club members connect and share local
          knowledge...
        </p>
      </div>
      <Link
        to="/register"
        className="mx-auto w-3/4 text-center bg-white text-blue-600 font-bold py-2 px-4 rounded-full hover:bg-gray-200 transition duration-200 self-center"
      >
        Join the GL Club Free
      </Link>
    </div>
  );
};

export default ContributeBanner;
